// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"3566127f","171":"e4d3229c","378":"46eec200","453":"48b2b501"}[chunkId] + ".chunk.js";
};